"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SwapContext_1 = require("src/contexts/SwapContext");
const Form_1 = __importDefault(require("../../components/Form"));
const FormPairSelector_1 = __importDefault(require("../../components/FormPairSelector"));
const cn_1 = require("src/misc/cn");
const InitialScreen = () => {
    const { form, setForm, loading } = (0, SwapContext_1.useSwapContext)();
    const [isDisabled, setIsDisabled] = (0, react_1.useState)(false);
    const [selectPairSelector, setSelectPairSelector] = (0, react_1.useState)(null);
    const onSelectMint = (0, react_1.useCallback)((tokenInfo) => __awaiter(void 0, void 0, void 0, function* () {
        if (selectPairSelector === 'fromMint') {
            setForm((prev) => (Object.assign(Object.assign(Object.assign({}, prev), { fromMint: tokenInfo.id, fromValue: '' }), (prev.toMint === tokenInfo.id ? { toMint: prev.fromMint } : undefined))));
        }
        else {
            setForm((prev) => (Object.assign(Object.assign(Object.assign({}, prev), { toMint: tokenInfo.id, toValue: '' }), (prev.fromMint === tokenInfo.id ? { fromMint: prev.toMint } : undefined))));
        }
        setSelectPairSelector(null);
    }), [selectPairSelector, setForm]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("form", { className: (0, cn_1.cn)({
                    hidden: Boolean(selectPairSelector),
                }), children: (0, jsx_runtime_1.jsx)(Form_1.default, { isDisabled: isDisabled, setSelectPairSelector: setSelectPairSelector }) }), selectPairSelector !== null ? ((0, jsx_runtime_1.jsx)("div", { className: "absolute top-0 left-0 h-full w-full bg-black rounded-lg overflow-hidden", children: (0, jsx_runtime_1.jsx)(FormPairSelector_1.default, { onSubmit: onSelectMint, onClose: () => setSelectPairSelector(null) }) })) : null] }));
};
exports.default = InitialScreen;
